function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.728 6A2.73 2.73 0 0 0 9 8.729v19.545A2.73 2.73 0 0 0 11.728 31h14.09a2.73 2.73 0 0 0 2.728-2.727V12.254l-6.254-6.253H11.728zM25.82 28.273H11.728V8.727h8.636v5.454h5.455v14.091zM4 25V4c0-1.655 1.345-3 3-3h10.75c1.653 0 3 1.345 3 3H7v24c-1.655 0-3-1.346-3-3z"
});

var SvgCopy = function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1B1F23",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "c7794e0e89152818f4c3497e3e8ef1fc.svg";
export { SvgCopy as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/copy.svg
// module id = null
// module chunks = 